/* pdp-gallery.js – Galerie-Erweiterungen der Produktseite (Besitzer: Agent «Medien & Performance»).
   Ergänzt theme.js (initGallery: Pfeile, Thumbs, Zähler, Variantenwechsel) und ersetzt nichts davon:
   - Punkte-Indikator, aktives Thumb in den Blick scrollen, aria-current
   - sanfter Wechsel bei weiten Sprüngen (Variantenwechsel) statt langem Durchscrollen
   - Hover-Zoom (nur Maus), Lightbox (<dialog>) mit Pfeilen, Wischen, ESC, Zähler, Desktop-Klick-Zoom
   - Video-Fassade (externe Videos laden erst nach Klick), laufende Videos pausieren beim Weiterblättern */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function init(root) {
    if (root.getAttribute('data-pdp-ready')) return;
    root.setAttribute('data-pdp-ready', '1');

    var track = qs('[data-gallery-track]', root);
    if (!track) return;
    var slides = qsa('.gallery__slide', track);
    var thumbsWrap = qs('[data-gallery-thumbs]', root);
    var thumbs = qsa('[data-thumb]', root);
    var dots = qsa('[data-gallery-dot]', root);
    var zoomBtn = qs('[data-gallery-zoom]', root);
    var prevBtn = qs('[data-gallery-prev]', root);
    var nextBtn = qs('[data-gallery-next]', root);
    var lightbox = initLightbox(root, track, slides, zoomBtn);

    var startThumb = thumbs.findIndex(function (t) { return t.classList.contains('is-active'); });
    var index = Math.max(0, startThumb);

    function currentIndex() {
      var w = track.clientWidth;
      return w ? clamp(Math.round(track.scrollLeft / w), 0, slides.length - 1) : index;
    }

    function centerThumb(i) {
      var t = thumbs[i];
      if (!thumbsWrap || !t || thumbsWrap.scrollWidth <= thumbsWrap.clientWidth + 1) return;
      var left = t.offsetLeft - (thumbsWrap.clientWidth - t.offsetWidth) / 2;
      thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }

    function resetEmbeds(except) {
      slides.forEach(function (s, n) {
        if (n === except) return;
        qsa('video', s).forEach(function (v) { if (!v.paused) v.pause(); });
        var frame = qs('iframe[data-pdp-embed]', s);
        if (frame) {
          frame.remove();
          var facade = qs('.gallery__embed', s);
          if (facade) facade.hidden = false;
        }
      });
    }

    function update(i, first) {
      index = i;
      thumbs.forEach(function (t, n) {
        if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
      });
      if (zoomBtn) {
        var type = slides[i] && slides[i].getAttribute('data-media-type');
        zoomBtn.hidden = type !== 'image';
      }
      if (!first) { centerThumb(i); resetEmbeds(i); }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var i = currentIndex();
        if (i !== index) update(i, false);
      });
    }, { passive: true });

    /* Weite Sprünge (Variantenwechsel zu einem entfernten Bild): sofort springen + kurzes Einblenden,
       einzelne Schritte (Pfeile, Thumbs daneben) bleiben weich. Greift nur auf scrollTo({left}) dieses Tracks. */
    var nativeScrollTo = track.scrollTo.bind(track);
    var flashTimer = 0;
    track.scrollTo = function (a) {
      if (a && typeof a === 'object' && typeof a.left === 'number' && a.behavior === 'smooth') {
        var w = track.clientWidth || 1;
        if (Math.abs(Math.round(a.left / w) - currentIndex()) > 1) {
          nativeScrollTo({ left: a.left, behavior: 'auto' });
          if (!reduceMotion.matches) {
            track.classList.remove('is-jumping');
            void track.offsetWidth;
            track.classList.add('is-jumping');
            window.clearTimeout(flashTimer);
            flashTimer = window.setTimeout(function () { track.classList.remove('is-jumping'); }, 400);
          }
          return;
        }
      }
      /* arguments statt (a, b): scrollTo(opts, undefined) würde als scrollTo(x, y) = (NaN, NaN) gelesen */
      return nativeScrollTo.apply(track, arguments);
    };

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = Number(dot.getAttribute('data-gallery-dot'));
        if (thumbs[i]) thumbs[i].click();
        else track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });

    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowLeft' && prevBtn) { e.preventDefault(); prevBtn.click(); }
      else if (e.key === 'ArrowRight' && nextBtn) { e.preventDefault(); nextBtn.click(); }
    });

    /* Hover-Zoom: nur Maus, Ursprung folgt dem Zeiger (reine CSS-Variablen, kein Layout) */
    if (finePointer.matches) {
      track.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse') return;
        var slide = e.target.closest ? e.target.closest('.gallery__slide') : null;
        if (!slide) return;
        var r = slide.getBoundingClientRect();
        slide.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        slide.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      }, { passive: true });
    }

    /* Klick/Tipp auf das Bild und der Lupen-Button öffnen die Lightbox */
    if (lightbox) {
      track.addEventListener('click', function (e) {
        var img = e.target.closest ? e.target.closest('.gallery__slide[data-media-type="image"] > img') : null;
        if (img) lightbox.open(currentIndex(), zoomBtn);
      });
      if (zoomBtn) zoomBtn.addEventListener('click', function () { lightbox.open(currentIndex(), zoomBtn); });
      if (finePointer.matches) {
        root.addEventListener('pointerenter', function () { lightbox.warm(currentIndex()); }, { once: true });
      }
    } else if (zoomBtn) {
      zoomBtn.remove();
    }

    /* Externe Videos: Dritt-Skripte erst nach Klick (Fassade mit Poster) */
    qsa('.gallery__embed', track).forEach(function (facade) {
      facade.addEventListener('click', function () {
        var frame = document.createElement('iframe');
        frame.setAttribute('data-pdp-embed', '1');
        frame.src = facade.getAttribute('data-embed');
        frame.title = facade.getAttribute('data-embed-title') || '';
        frame.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
        frame.setAttribute('allowfullscreen', '');
        frame.setAttribute('loading', 'lazy');
        facade.hidden = true;
        facade.parentNode.appendChild(frame);
        frame.focus();
      });
    });

    update(index, true);
    if (startThumb > 0) centerThumb(index);
  }

  function initLightbox(root, track, slides, zoomBtn) {
    var dlg = qs('[data-lightbox]', root);
    if (!dlg || typeof dlg.showModal !== 'function') return null;
    var lbTrack = qs('[data-lightbox-track]', dlg);
    var lbSlides = qsa('.lightbox__slide', lbTrack);
    var lbCount = qs('[data-lightbox-count]', dlg);
    var closeBtn = qs('[data-lightbox-close]', dlg);
    var prev = qs('[data-lightbox-prev]', dlg);
    var next = qs('[data-lightbox-next]', dlg);
    if (!lbSlides.length) return null;
    var lbIndex = 0;
    var opener = null;
    var ticking = false;
    var lockUntil = 0;
    var lockTimer = 0;

    function eager(i) {
      [i - 1, i, i + 1].forEach(function (n) {
        var img = lbSlides[n] && qs('img', lbSlides[n]);
        if (img && img.loading !== 'eager') img.loading = 'eager';
      });
    }

    function resetZoom() {
      lbSlides.forEach(function (s) { s.classList.remove('is-zoomed'); });
    }

    function setIndex(i) {
      lbIndex = i;
      if (lbCount) {
        lbCount.textContent = lbSlides.length > 1 ? (i + 1) + ' / ' + lbSlides.length : '';
        lbCount.hidden = lbSlides.length < 2;
      }
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === lbSlides.length - 1;
      eager(i);
    }

    function goTo(i, smooth) {
      i = clamp(i, 0, lbSlides.length - 1);
      resetZoom();
      var animate = smooth && !reduceMotion.matches;
      /* Während des weichen Scrollens bestimmt das Ziel den Zähler, nicht die Zwischenstände (kein Zurückspringen) */
      lockUntil = animate ? Date.now() + 650 : 0;
      window.clearTimeout(lockTimer);
      if (animate) lockTimer = window.setTimeout(syncFromScroll, 700);
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: animate ? 'smooth' : 'auto' });
      setIndex(i);
    }

    function syncFromScroll() {
      var w = lbTrack.clientWidth;
      if (!w) return;
      var i = clamp(Math.round(lbTrack.scrollLeft / w), 0, lbSlides.length - 1);
      if (i !== lbIndex) { resetZoom(); setIndex(i); }
    }

    lbTrack.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        if (Date.now() < lockUntil) return;
        syncFromScroll();
      });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(lbIndex - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(lbIndex + 1, true); });
    if (closeBtn) closeBtn.addEventListener('click', function () { dlg.close(); });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(lbIndex - 1, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); goTo(lbIndex + 1, true); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0, true); }
      else if (e.key === 'End') { e.preventDefault(); goTo(lbSlides.length - 1, true); }
    });

    function setOrigin(slide, e) {
      var img = qs('img', slide);
      var r = slide.getBoundingClientRect();
      var px = clamp((e.clientX - r.left - img.offsetLeft) / (img.offsetWidth || 1) * 100, 0, 100);
      var py = clamp((e.clientY - r.top - img.offsetTop) / (img.offsetHeight || 1) * 100, 0, 100);
      slide.style.setProperty('--zx', px.toFixed(1) + '%');
      slide.style.setProperty('--zy', py.toFixed(1) + '%');
    }

    /* Klick neben das Bild schliesst; Klick aufs Bild zoomt (nur Maus), Touch nutzt das native Pinch-Zoomen */
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t === dlg || t === lbTrack || (t.classList && t.classList.contains('lightbox__slide'))) { dlg.close(); return; }
      if (t.tagName === 'IMG' && finePointer.matches) {
        var slide = t.closest('.lightbox__slide');
        if (slide) {
          var was = slide.classList.contains('is-zoomed');
          resetZoom();
          if (!was) { setOrigin(slide, e); slide.classList.add('is-zoomed'); }
        }
      }
    });
    lbTrack.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      var slide = e.target.closest ? e.target.closest('.lightbox__slide.is-zoomed') : null;
      if (slide) setOrigin(slide, e);
    }, { passive: true });

    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('pdp-lb-open');
      resetZoom();
      /* Hauptgalerie auf das zuletzt gesehene Bild setzen */
      var cur = lbSlides[lbIndex];
      var id = cur && cur.getAttribute('data-lb-media-id');
      var target = slides.filter(function (s) { return s.getAttribute('data-media-id') === id; })[0];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'auto' });
      var back = opener && document.contains(opener) ? opener : zoomBtn;
      if (back && !back.hidden) back.focus({ preventScroll: true });
    });

    return {
      warm: function (slideIndex) {
        var conn = navigator.connection;
        if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;
        var id = slides[slideIndex] && slides[slideIndex].getAttribute('data-media-id');
        var i = lbSlides.findIndex(function (s) { return s.getAttribute('data-lb-media-id') === id; });
        if (i >= 0) eager(i);
      },
      open: function (slideIndex, from) {
        var id = slides[slideIndex] && slides[slideIndex].getAttribute('data-media-id');
        var i = lbSlides.findIndex(function (s) { return s.getAttribute('data-lb-media-id') === id; });
        if (i < 0) i = 0;
        opener = from || document.activeElement;
        document.documentElement.classList.add('pdp-lb-open');
        dlg.showModal();
        goTo(i, false);
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      },
    };
  }

  function boot() { qsa('[data-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
